import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { CardNotificationComponent } from './components/card-notification/card-notification.component';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { MaskCpfPipe } from '../shared/pipes/mask-cpf.pipe';
import { ModalUserAlterPasswordComponent } from './components/user-alterpassword/modal-user-alterpassword.component';
import { SharedComponentModule } from '../shared/components/shared-component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MxCommonsModule } from 'mx-commons';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { ModalChangePermissionComponent } from './components/change-permission/modal-change-permission.component';
import { ModalService } from '../shared/services/modal.service';
import { ModalNotificationComponent } from './components/modal-notification/modal-notification.component';
import { ModalNotificationListComponent } from './modals/notificacao/notificacao.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MxCommonsModule,
		LayoutRoutingModule,
		TranslateModule,
		NgbDropdownModule,
		SharedPipesModule,
		SharedComponentModule,
		Ng2ImgMaxModule
	],
	declarations: [LayoutComponent, SidebarComponent, HeaderComponent, ModalUserAlterPasswordComponent, ModalChangePermissionComponent, CardNotificationComponent, ModalNotificationComponent, ModalNotificationComponent, ModalNotificationListComponent],
	entryComponents: [ModalUserAlterPasswordComponent, ModalChangePermissionComponent, ModalNotificationComponent, ModalNotificationListComponent],
	providers: [MaskCpfPipe, ModalService]
})
export class LayoutModule { }
